import styles from "./styles/custom-dataset-limit-modal.module.scss";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
import { useRouter } from "next/navigation";
import React, { useEffect } from "react";
import IncreaseLimitsButton from "@/components/common/increase-limits-button";
import { LicenseName } from "@/data/license.data";
import FilledButton from "@/components/common/filled-button";
import Link from "next/link";
import { useCustomLimitations } from "@/components/pages/custom/hooks/use-custom-limitations";
import Loader from "@/components/common/loader";

interface CustomDatasetLimitModalProps {
  licenseName: LicenseName;
}

const CustomDatasetLimitModal = ({
  licenseName,
}: CustomDatasetLimitModalProps) => {
  const { hideModal } = useGlobalModalContext();
  const { durationMax, isLoading } = useCustomLimitations();
  const router = useRouter();
  useEffect(() => {
    if (licenseName === "Studio") {
      router.push("/help/contact");
    } else {
      router.push("/pricing");
    }
  }, [licenseName, router]);

  return (
    <div className={styles.trial_modal}>
      <div className={styles.main_text}>
        Thank you for using <br /> {licenseName.toLowerCase()} version of
        AudioModify!
      </div>
      <div className={styles.sub_container}>
        {isLoading ? (
          <Loader />
        ) : (
          <div>
            Your plan allows you to upload datasets with a length of up to{" "}
            {durationMax} minutes.
          </div>
        )}

        <div>
          {licenseName === "Studio"
            ? "Please contact support@audiomodify.com to increase dataset length limits."
            : "Upgrade to a higher plan to upload longer datasets."}
        </div>
      </div>
      {licenseName !== "Studio" && (
        <IncreaseLimitsButton filled={true} onClick={hideModal} />
      )}
      {licenseName === "Studio" && (
        <Link href={"/help/contact"}>
          <FilledButton text={"INCREASE LIMITS"} onClick={hideModal} />
        </Link>
      )}
    </div>
  );
};

export default CustomDatasetLimitModal;
